const breakpoints = new Map();
// Tailwind breakpoints
breakpoints.set('default', 0);
breakpoints.set('small', 500);
breakpoints.set('medium', 768);
breakpoints.set('large', 1024);
breakpoints.set('xlarge', 1280);

module.exports = breakpoints;